import axios from 'axios';
import qs from 'qs';
import headers from './Headers';

function request(method, endpoint, settings, data = null, authorized = true, params = null) {
    return new Promise((resolve, reject) => {
        axios({
            method,
            url: `${settings.endpoint}${endpoint}`,
            data,
            headers: headers({
                language: settings.localization,
                token: authorized ? settings.auth.token : null,
            }),
            params: qs.parse(params),
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
}


export default request;
